import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField, normalizeInteger } from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import { integerFormat } from 'common/helpers/numberHelper';
import { addWish } from 'redux/allocationWishes/actions';

import { validateAllocationWish } from './validators';

class WishForm extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    data.productId = props.product.id;
    const successFunction = () => {
      props.onCloseModal();
    };
    props.addWish(
      props.allocation.allocationId,
      data,
      props.product.slug,
      successFunction
    );
  };

  render() {
    const { allocation, onCloseModal, handleSubmit } = this.props;
    return (
      <Modal title="Allocation Wish" onCloseModal={onCloseModal}>
        <div className="c7-allocation" key={allocation.allocationId}>
          <div className="c7-allocation__title">{allocation.title}</div>
          <div className="c7-allocation__quantity">
            <span>Allocated Quantity: </span> {allocation.minQuantity} -{' '}
            {allocation.maxQuantity}
          </div>

          {allocation.additionalGrant > 0 && (
            <>
              <div className="c7-allocation__additional">
                <span>Additional Granted: </span> {allocation.additionalGrant}
              </div>
            </>
          )}
          {allocation.quantityPurchased > 0 && (
            <div className="c7-allocation__prev">
              <span>Prev Purchased: </span> {allocation.quantityPurchased}
            </div>
          )}
        </div>

        <br />
        <h3>Wish For More</h3>
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form c7-form--allocation-request"
        >
          {/* <FormError formName={form} /> */}
          <Field
            name="wishQuantity"
            label="Wish Quantity"
            component={TextField}
            normalize={normalizeInteger}
            required
          />
          <div>
            <button type="submit" className="c7-button">
              Wish For More
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    wishQuantity: values.wishQuantity && integerFormat(values.wishQuantity)
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateAllocationWish(data);
  return errors;
};

WishForm = reduxForm({
  form: 'wishForm',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(WishForm);

const mapStateToProps = (state, ownProps) => {
  const initialValues = {
    wishQuantity: ownProps.allocation.wishQuantity
  };
  if (initialValues.wishQuantity === 0) {
    initialValues.wishQuantity = 1;
  }
  return {
    initialValues
  };
};

export default connect(mapStateToProps, { addWish })(WishForm);
